import { Box, Divider, Grid, Typography } from "@mui/material";
import { CommonStyle, ControlledTable, Loader } from "Components";
import { DropdownArrPropsType, FormDataType } from "DataTypes/Form";
import { AddProviderFormType } from "DataTypes/PatientManagement.type";
import { FC, Fragment, useEffect, useState } from "react";
import CarePlanApi from "Service/CarePlan.api";
import CPFormatter from "Utils/CP.Formatter";
import { commonFormSwitch } from "Utils/SwitchCases";
import { CCTableCol, FormArr1, FormArr2, TblActionArr } from "./Data";
import ImgPath from "Constant/Imgs";
import { ModalLayout, TableLayout } from "Layouts";
import { DeleteButtonArray } from "Components/Modal/Data";
import { useDispatch } from "react-redux";
import { setAlertData, setFormLoader } from "Redux/Screen/Action";
import CstmBtn from "Components/CstmBtn";
import { EligiblePrgmResType } from "DataTypes/Services/Patient.type";
import { PatientInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import UserApi from "Service/User.api";
import UsersFormatter from "Utils/Users.Formatter";
import { FormatDropdownData } from "Utils/DataFormatter";
import {
  CheckArr,
  CheckNumber,
  HandleFormChange,
  ValidateFormData
} from "Utils/common";
import { HandleChangeProps } from "DataTypes/Common";
import {
  CPTeamCoordinatorType,
  CPTeamSearchType1
} from "DataTypes/Services/Careplan.type";

interface ReusableCTProps {
  addAddProviders: boolean; ///Permission to Add / Delete addition provider
  displayNextBtn: boolean;
  displaySaveBtn: boolean;
  displaySaveNextBtn: boolean;
  editAddProviders: boolean; ///Permission to edit addition provider
  filterForm1EmptyFields: boolean;
  filterForm2EmptyFields: boolean;
  handleNext?: () => void;
  handleSave?: () => void;
  handleSaveNext?: () => void;
  openAllForSA: boolean;
  prgmDetails: EligiblePrgmResType
  editCareTeam: boolean;
}

const ReusableCTUI: FC<ReusableCTProps> = (props) => {
  const {
    addAddProviders,
    displayNextBtn,
    displaySaveBtn,
    displaySaveNextBtn,
    editAddProviders,
    filterForm1EmptyFields,
    filterForm2EmptyFields,
    handleNext,
    handleSave,
    handleSaveNext,
    openAllForSA,
    prgmDetails,
    editCareTeam,
  } = props;
  const dispatch = useDispatch();
  const { patientOrg }: PatientInitialStateType =
    useSelector((state: any) => state?.patient);
  const patientLocId = patientOrg.practiceLocationId;
  const { abbrevation, careplanId } = prgmDetails;
  const form1ReadOnly = !editCareTeam;
  const form2ReadOnly = !editAddProviders && !addAddProviders;
  const [formData1, setFormData1] = useState<FormDataType[]>([]);
  const [formData2, setFormData2] = useState<AddProviderFormType[]>([]);
  const [deleteProvider, setDeleteProvider] =
    useState<AddProviderFormType | null>(null);
  const [careCoordArr, setCareCoordArr] = useState<DropdownArrPropsType[]>([]);
  const [saveReadData, setSaveReadData] =
    useState<CPTeamSearchType1 | null>(null);
  const [cstmLoader, setCstmLoader] = useState(true);
  const [selectedCC, setSelectedCC] = useState<CPTeamCoordinatorType[]>([]);

  useEffect(() => {
    InitialLoad();
  }, []);

  const InitialLoad: () => void = async () => {
    const { cmArr, ccArr, provArr } = await loadLists()
    ///Care plan team read api
    const res = await CarePlanApi.CPTeamSearch({ id1: careplanId });
    if (res.success) {
      ///Care plan team formatted data
      const checkedRes = CPFormatter.CheckCPTeam1(res?.data);
      setSaveReadData(checkedRes);
      // If Admin checking this UI from Edit screen then caremanager..
      // should be open irrescpective of the team initiator.
      ///Else check whether team is initiated by care manager or provider.
      ///<---Work started for form arr 1--->
      const CPInitiatedByCM =
        openAllForSA || checkedRes.teamInitiatorRoleId == 5 ? false : true;
      const CPInitiatedByProvider =
        openAllForSA || checkedRes.teamInitiatorRoleId == 3 ? false : true;
      ///In case of TCM, coordinators not required;
      const showCoordinators = abbrevation == "TCM" ? false : true;
      const showCPBP = checkedRes.teamInitiatorRoleId == 5;
      const showLabelCP =
        (abbrevation == "TCM" || abbrevation == "RPM") ? false : true;
      let newArr1: FormDataType[] = FormArr1(
        {
          CPInitiatedByCM,
          CPInitiatedByProvider,
          form1ReadOnly,
          showCoordinators,
          showCPBP,
          showLabelCP
        }
      );
      const newRes = JSON.parse(JSON.stringify(checkedRes));
      const primCC = checkedRes.careplanCoordinators.find(
        el1 => el1.sequence == 1
      )
      const secCCArr = checkedRes.careplanCoordinators.filter(
        filEl => filEl.sequence != 1
      );
      setSelectedCC(secCCArr);
      newArr1 = newArr1.map(formEl => {
        if (formEl.boxType == "input-box") formEl.value = newRes[formEl.id];
        if (
          formEl.boxType == "single-select-drop" ||
          formEl.boxType == "multi-select-drop"
        ) {
          formEl.dropValue = newRes[formEl.id];
          ///Set droparr accordingly to different form obj
          if (formEl.id == "caremanagerId") formEl.dropArr = cmArr;
          if (formEl.id == "billableProviderId") formEl.dropArr = provArr;
          if (formEl.id == "teamProviderId") formEl.dropArr = provArr;
          if (formEl.id == "supervisionProviderId") formEl.dropArr = provArr;
          if (formEl.id == "primaryCareCoordinatorId") {
            formEl.dropArr = form1ReadOnly ?
              FormatDropdownData(
                [primCC],
                "coordinatorId",
                "careCoordinator",
                "coordinatorId"
              )
              :
              ccArr.filter(el => {
                const find = checkedRes.careplanCoordinators.find(el1 => {
                  if (el1?.coordinatorId == el.value && el1.sequence != 1) {
                    return el
                  }
                })
                if (!find) return el;
              })
            formEl.dropValue = primCC?.coordinatorId;
          }
          if (formEl.id == "careplanCoordinators") {
            formEl.dropArr = form1ReadOnly ?
              FormatDropdownData(
                secCCArr,
                "coordinatorId",
                "careCoordinator",
                "coordinatorId"
              )
              :
              ccArr.filter(el => el.value != primCC?.coordinatorId)
            formEl.dropValue = secCCArr.map(el => el?.coordinatorId);
          }
        }
        return formEl
      });
      ///Filter out empty field is client requirement on sidebar screen
      if (filterForm1EmptyFields) {
        newArr1 = newArr1.filter(formEl => {
          if (formEl.boxType == "input-box" && formEl.value) return formEl
          else if (
            formEl.boxType == "single-select-drop" &&
            formEl.dropValue) return formEl
          else {
            if (CheckArr(formEl.dropValue).length > 0) return formEl
          }
        })
      }
      ///<---Work completed for form arr 1--->
      ///<---Work started for form arr 2--->
      let newArr2: AddProviderFormType[] = [];
      if (checkedRes.careplanAdditionalProvider.length) {
        checkedRes.careplanAdditionalProvider.forEach((resEl, index) => {
          const newResEl = JSON.parse(JSON.stringify(resEl));
          const newFormArr2: FormDataType[] =
            JSON.parse(JSON.stringify(FormArr2));
          let newAddForm = newFormArr2.map(formEl => {
            formEl.value = newResEl[formEl.id];
            formEl.readOnly = form2ReadOnly
            return formEl
          })
          ///Filter out empty field is client requirement on sidebar screen
          if (filterForm2EmptyFields) {
            newAddForm = newAddForm.filter(el => el.value)
          }
          newArr2.push({
            addProviderId: newResEl?.id || null,
            formArr: newAddForm,
            id: index + 1
          })
        });
      }
      ///Filter out empty field is client requirement on sidebar screen
      if (filterForm2EmptyFields) {
        newArr2 = newArr2.filter(formEl => formEl.addProviderId)
      }
      ///<---Work completed for form arr 2--->
      setFormData1(newArr1);
      setFormData2(newArr2);
    }
    setCstmLoader(false);
  };

  const loadLists: () => Promise<{
    cmArr: DropdownArrPropsType[],
    provArr: DropdownArrPropsType[],
    ccArr: DropdownArrPropsType[],
  }> = async () => {
    let cmArr: DropdownArrPropsType[] = [];
    let provArr: DropdownArrPropsType[] = [];
    let ccArr: DropdownArrPropsType[] = [];
    const providerUserPayload = {
      data: { practiceLocationId: patientLocId, roleId: 5 },
    };
    const careCoordinatorUserPayload = {
      data: { practiceLocationId: patientLocId, roleId: 4 },
    };
    const careManagerUserPayload = {
      data: { practiceLocationId: patientLocId, roleId: 3 },
    };
    if (!form1ReadOnly) {
      const providerRes = await UserApi.list(providerUserPayload);
      if (providerRes?.success) {
        let newArr = UsersFormatter.VerifyListArrResponse(providerRes?.data);
        newArr = newArr.filter(el => el.status !== "INACTIVE");
        provArr = FormatDropdownData(newArr, "id", "fullNameDes", "id");
      }
      const ccRes = await UserApi.list(careCoordinatorUserPayload);
      if (ccRes?.success) {
        let newArr = UsersFormatter.VerifyListArrResponse(ccRes?.data);
        newArr = newArr.filter(el => el.status !== "INACTIVE");
        ccArr = FormatDropdownData(newArr, "id", "fullNameDes", "id");
        setCareCoordArr(ccArr);
      }
      const cmRes = await UserApi.list(careManagerUserPayload);
      if (cmRes?.success) {
        let newArr = UsersFormatter.VerifyListArrResponse(cmRes?.data);
        newArr = newArr.filter(el => el.status !== "INACTIVE");
        cmArr = FormatDropdownData(newArr, "id", "fullNameDes", "id");
      }
    }
    return { cmArr, provArr, ccArr }
  };

  const handleForm1Change: (val: HandleChangeProps) => void = (val) => {
    const { id, value } = val;
    let newFormArr: FormDataType[] = JSON.parse(JSON.stringify(formData1));
    if (id == "primaryCareCoordinatorId") {
      newFormArr = newFormArr.map(formEl => {
        if (formEl.id == "careplanCoordinators") {
          formEl.dropArr = careCoordArr.filter(filEl => filEl?.value != value)
        }
        return formEl;
      })
    }
    if (id == "careplanCoordinators") {
      newFormArr = newFormArr.map(formEl => {
        if (formEl.id == "primaryCareCoordinatorId") {
          formEl.dropArr = careCoordArr.filter(filEl => {
            const find = CheckArr(value).find(findEl => findEl == filEl.value);
            if (!find) return filEl
          })
        }
        return formEl;
      })
      const newArr: CPTeamCoordinatorType[] = [];
      CheckArr(value).forEach(el => {
        const foundInArr = saveReadData?.careplanCoordinators.find(
          el1 => el1?.coordinatorId == el
        );
        if (foundInArr) newArr.push(foundInArr);
        else {
          const foundInUserArr = careCoordArr.find(el1 => el1.value == el);
          if (foundInUserArr) {
            const name = foundInUserArr.label.split(", ")[0];
            const desgn = foundInUserArr.label.split(", ")[1];
            newArr.push({
              careCoordinator: foundInUserArr.label,
              careCoordinatorDesignation: desgn,
              careCoordinatorName: name,
              coordinatorId: CheckNumber(foundInUserArr.value),
              id: `new${foundInUserArr.value}`,
              sequence: newArr.length + 2,
              status: "ACTIVE"
            });
          }
        }
      })
      setSelectedCC(newArr);
    }
    setFormData1(HandleFormChange(val, newFormArr));
  };

  const handleForm2Change: (
    val: HandleChangeProps, formIndex: number
  ) => void = (val, formIndex) => {
    const { id, value } = val;
    const findSecIndex = formData2.findIndex((el) => el.id == formIndex);
    const findObjIndex = formData2[findSecIndex].formArr.findIndex(
      (el) => el.id == id
    );
    const newFormArr: AddProviderFormType[] =
      JSON.parse(JSON.stringify(formData2));
    newFormArr[findSecIndex].formArr[findObjIndex].value = value;
    setFormData2(newFormArr);
  };

  const removeProvider: (obj: AddProviderFormType) => void = async (obj) => {
    if (obj.addProviderId) setDeleteProvider(obj)
    else {
      let newArr = formData2.filter((el: any) => el?.id != obj.id);
      newArr = newArr.map((el, index) => {
        el.id = index + 1;
        return el;
      });
      setFormData2(newArr);
    }
  };

  const deleteSavedProvider: () => void = async () => {
    if (deleteProvider) {
      const res = await CarePlanApi.DeleteAddProvider({
        id1: careplanId,
        id2: deleteProvider?.addProviderId,
      });
      if (res?.success) {
        dispatch(setAlertData(res?.alert));
        removeProvider({ ...deleteProvider, addProviderId: null })
      }
      setDeleteProvider(null);
    }
  };

  const handleCCDelete: (data: CPTeamCoordinatorType) => void = (data) => {
    setSelectedCC(selectedCC.filter(el => el.id != data.id));
    let newFormArr: FormDataType[] = JSON.parse(JSON.stringify(formData1));
    newFormArr = newFormArr.map(el => {
      if (el.id == "careplanCoordinators") {
        el.dropValue = CheckArr(el.dropValue).filter(
          el1 => el1 != data?.coordinatorId
        );
      }
      return el;
    });
    setFormData1(newFormArr);
  }

  const handleAddProvider: () => void = () => {
    setFormData2([
      ...formData2,
      {
        id: formData2.length + 1,
        addProviderId: null,
        formArr: JSON.parse(JSON.stringify(FormArr2)),
      },
    ]);
  };

  const handleSaveTeam: () => Promise<boolean> = async () => {
    let errorCheck = false;
    const newArr = ValidateFormData(formData1);
    if (newArr.errorCheck) errorCheck = true;
    setFormData1(newArr?.formData);
    const newArr2 = formData2.map((el) => {
      const newArr3 = ValidateFormData(el.formArr);
      if (newArr3.errorCheck) errorCheck = true;
      el.formArr = newArr3?.formData;
      return el;
    });
    setFormData2(newArr2);
    if (!errorCheck) {
      dispatch(setFormLoader(true));
      const addProviderArr: any[] = [];
      formData2.forEach((el) => {
        let newObj = {
          id: el.addProviderId,
          careplanId: prgmDetails.careplanId,
          programId: prgmDetails.programId,
          patientId: prgmDetails.patientId,
          practiceId: prgmDetails.practiceId,
          practiceLocationId: prgmDetails.practiceLocationId,
        };
        el.formArr.forEach(formEl => {
          newObj = { ...newObj, [formEl.id]: formEl.value }
        })
        addProviderArr.push(newObj);
      });
      const primCC = saveReadData?.careplanCoordinators.find(
        el => el.sequence == 1);
      let teamObj: any = {
        careplanId: prgmDetails.careplanId,
        programId: prgmDetails.programId,
        patientId: prgmDetails.patientId,
        practiceId: prgmDetails.practiceId,
        practiceLocationId: prgmDetails.practiceLocationId,
        careplanAdditionalProvider: addProviderArr,
        isCareplanStateUpdateRequire: true,
        careplanCoordinators: [
          {
            "id": CheckNumber(primCC?.id) || null,
            "careCoordinatorId": formData1.find(
              formEl => formEl.id == "primaryCareCoordinatorId"
            )?.dropValue,
            "sequence": 1
          }, ...selectedCC.map((el, i) => {
            return {
              "id": typeof el.id == "number" ? el.id : null,
              "careCoordinatorId": el?.coordinatorId,
              "sequence": i + 2
            }
          })
        ],
        primaryCareCoordinatorId: null,
        secondaryCareCoordinatorId: null,
      };
      if (displaySaveBtn || openAllForSA) {
        ///This means user is saving team details on edit screen or
        // Super admin save team from revision flow
        // therefore no need to change care plan state
        teamObj = { ...teamObj, isCareplanStateUpdateRequire: false }
      }
      if (form1ReadOnly) {
        teamObj = {
          ...teamObj,
          caremanagerId: saveReadData?.caremanagerId,
          billableProviderId: saveReadData?.billableProviderId,
          teamProviderId: saveReadData?.teamProviderId,
          supervisionProviderId: saveReadData?.supervisionProviderId,
          authorizedRepresentative1: saveReadData?.authorizedRepresentative1,
          authorizedRepresentative2: saveReadData?.authorizedRepresentative2,
          authorizedRepresentative3: saveReadData?.authorizedRepresentative3,
        }
      } else {
        formData1.forEach(formEl => {
          let value = null;
          if (formEl.boxType == "single-select-drop" &&
            formEl.id != "primaryCareCoordinatorId") value = formEl.dropValue;
          if (formEl.boxType == "input-box") value = formEl.value;
          if (formEl.id != "careplanCoordinators") {
            teamObj = {
              ...teamObj,
              [formEl.id]: value
            }
          }
        })
      }
      const res = await CarePlanApi.CPTeamSave({
        id1: prgmDetails.careplanId,
        data: { data: teamObj },
      });
      if (res?.success) {
        dispatch(setAlertData(res?.alert));
        return true;
      } else dispatch(setFormLoader(false));
    }
    return false;
  }

  const ClickSaveBtn: () => void = async () => {
    const apiSuccess = await handleSaveTeam();
    if (apiSuccess && handleSave) handleSave();
  }

  const ClickSaveNextBtn: () => void = async () => {
    const apiSuccess = await handleSaveTeam();
    if (apiSuccess && handleSaveNext) handleSaveNext();
  };

  const PrimSection: JSX.Element = (
    <Grid container rowSpacing={1} columnSpacing={2} mb={2} pt={2}>
      {formData1.map((el) => {
        return el.boxType == "empty-block" ? (
          <Fragment />
        ) : (
          <Grid key={el.id} item {...{ md: 4, lg: 4, xl: 4 }}>
            {commonFormSwitch({
              formObj: el,
              onChange: (newVal) => handleForm1Change(newVal),
              enableFormLoad: true,
            })}
          </Grid>
        );
      })}
    </Grid>
  );

  const SelectedCoordinatorsSection: JSX.Element = (
    <TableLayout
      tblBody={
        <ControlledTable.TblBody
          tableColumn={() => CCTableCol}
          tableRow={selectedCC}
          tableAction={(data: CPTeamCoordinatorType) =>
            form1ReadOnly ? [] : TblActionArr(() => handleCCDelete(data))
          }
        />
      }
      tblHead={ControlledTable.TblHead(CCTableCol)}
      height={""}
    />
  )

  const SecSection: JSX.Element = (
    <Fragment>
      {formData2.map((el) => {
        return (
          <Fragment key={el.id}>
            <Divider />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={2}
              sx={{ mb: 2, mt: 1 }}
            >
              {el.formArr.map((formEl: FormDataType) => {
                return (
                  <Grid key={formEl.id} item {...{ md: 4, lg: 3, xl: 3 }}>
                    {formEl.id == "phoneNumber" && addAddProviders ? (
                      <Box display="flex">
                        <Box width="85%">
                          {commonFormSwitch({
                            formObj: formEl,
                            onChange: (data) => handleForm2Change(data, el.id),
                          })}
                        </Box>
                        <Box
                          width="15%"
                          mt={2}
                          sx={{ ...CommonStyle.sxRowCenter }}
                        >
                          <Box
                            sx={{ ...CommonStyle.sxRoundIconsMainSm }}
                            onClick={() => removeProvider(el)}
                            title="Delete"
                          >
                            <ImgPath.CloseIcon />
                          </Box>
                        </Box>
                      </Box>
                    ) : (
                      commonFormSwitch({
                        formObj: formEl,
                        onChange: (data) => handleForm2Change(data, el.id),
                      })
                    )}
                  </Grid>
                );
              })}
            </Grid>
          </Fragment>
        );
      })}
    </Fragment>
  );

  const BtnBoxSection: JSX.Element = (
    <Box sx={{ ...sxBtnBox }}>
      {addAddProviders && formData2.length < 5 && (
        <CstmBtn
          btnType="blue"
          label={"Add Additional Provider"}
          onClick={() => handleAddProvider()}
          enableFormLoad={true}
        />
      )}
      {displayNextBtn && (
        <CstmBtn
          label={"Next"}
          onClick={() => handleNext && handleNext()}
          width="10%"
          enableFormLoad={true}
        />
      )}
      {displaySaveNextBtn && (
        <CstmBtn
          label={"Save & Next"}
          onClick={ClickSaveNextBtn}
          width="10%"
          enableFormLoad={true}
        />
      )}
      {displaySaveBtn && (
        <CstmBtn
          label={"Save"}
          onClick={ClickSaveBtn}
          width="10%"
          enableFormLoad={true}
        />
      )}
    </Box>
  );

  if (cstmLoader) return <Loader />;

  return (
    <Fragment>
      <ModalLayout
        modwidth="30%"
        heading={"Warning"}
        content={
          <Typography textAlign={"center"}>
            Are you sure want to remove this Additional Provider?
          </Typography>
        }
        open={deleteProvider ? true : false}
        onClose={() => setDeleteProvider(null)}
        buttonArr={DeleteButtonArray(
          deleteSavedProvider,
          () => setDeleteProvider(null)
        )}
      />
      <Grid container rowSpacing={1} columnSpacing={2} mb={2}>
        <Grid item {...{ md: 9, lg: 9, xl: 9 }}>
          {PrimSection}
        </Grid>
        <Grid item {...{ md: 3, lg: 3, xl: 3 }} mt={2}>
          {SelectedCoordinatorsSection}
        </Grid>
      </Grid>
      {SecSection}
      {BtnBoxSection}
    </Fragment>
  )
};
export default ReusableCTUI;

const sxBtnBox = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  "& > button": { ml: 2 }
}
